import { supabase } from './supabaseClient';

export async function companyEmail(companyId, action = 'view', payload = {}) {
  const { data } = await supabase.auth.getSession();
  if (!data?.session?.access_token) throw new Error('Please sign in again.');
  const response = await fetch('/api/company-email', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${data.session.access_token}` },
    body: JSON.stringify({ ...payload, company_id: companyId, action })
  });
  const result = await response.json().catch(() => null);
  if (!response.ok) throw new Error(result?.error || result?.delivery?.error || 'Could not complete the email request.');
  return result;
}
export function withoutLegacyEmailCredentials(config) {
  if (!config || typeof config !== 'object' || Array.isArray(config)) return {};
  const settings = config.email_settings;
  if (!settings || typeof settings !== 'object' || Array.isArray(settings)) return config;
  const clean = Object.fromEntries(Object.entries(settings).filter(([key]) => !['apikey','password','token','accesstoken','refreshtoken'].includes(key.toLowerCase().replace(/_/g,''))));
  return { ...config, email_settings: clean };
}
export function clearLegacyEmailCaches(storage) {
  try {
    for (let index=0;index<storage.length;index++) {
      const key=storage.key(index);
      if (!key?.startsWith('co_config_')) continue;
      try { const current=storage.getItem(key),clean=JSON.stringify(withoutLegacyEmailCredentials(JSON.parse(current)));if(clean!==current)storage.setItem(key,clean); } catch (_) {}
    }
  } catch (_) {}
}
export const emailDeliveryLabel = status => ({ sending:'Sending', accepted:'Accepted by email service', delivered:'Delivered to mail server', failed:'Failed', bounced:'Bounced', complained:'Marked as spam', unknown:'Needs provider review' }[status] || status);
export function emailSendFeedback(result) {
  if (result.skipped && result.reason === 'already_setup') return 'Password setup is already complete. No invitation was sent; use Forgot password for recovery.';
  const status = result.delivery?.status;
  if (result.duplicate) return status === 'accepted' || status === 'delivered' ? 'This notification was already sent; no duplicate email was submitted.' : `A delivery already exists: ${emailDeliveryLabel(status)}. Check Email & Notifications history.`;
  if (status === 'unknown') return 'Sending could not be confirmed. Check provider history before sending again.';
  if (status === 'failed') return result.delivery.error || 'The email service rejected this message.';
  return 'Notification accepted by the email service. Check Email & Notifications for delivery status.';
}
